










































import Vue from 'vue';
import { Component, PropSync } from 'vue-property-decorator';

@Component({})
export default class AdminTab extends Vue {
	@PropSync('admin') public adminSettings: {
		restrictByIpEnabled: boolean,
		ips: string,
		uploadOnFTP: {
			enabled: boolean,
			host: string,
			port: string,
			login: string,
			password: string,
			uploadPath: string,
		},
	};
}
